import { NavLink } from "react-router-dom";
import { Home, ListChecks, Settings as SettingsIcon } from "lucide-react";

const items = [
  { to: "/app", label: "Home", icon: Home, testId: "nav-home", end: true },
  { to: "/app/reviews", label: "Reviews", icon: ListChecks, testId: "nav-reviews" },
  { to: "/app/settings", label: "Settings", icon: SettingsIcon, testId: "nav-settings" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 md:static md:border-t-0 md:border-r md:h-screen md:w-56 md:flex md:flex-col md:justify-start md:pt-8"
    >
      <div className="hidden md:block px-6 pb-8">
        <span className="brand-wordmark text-lg text-foreground">FINALLOOK</span>
      </div>
      <ul className="flex md:flex-col justify-around md:justify-start md:gap-1 md:px-3 px-2 py-2 md:py-0">
        {items.map(({ to, label, icon: Icon, testId, end }) => (
          <li key={to} className="flex-1 md:flex-none">
            <NavLink
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                `flex md:flex-row flex-col items-center md:gap-3 gap-1 md:justify-start justify-center md:px-4 px-2 md:py-2.5 py-2 rounded-xl text-xs md:text-sm font-medium ${
                  isActive
                    ? "text-primary md:bg-primary/10"
                    : "text-muted-foreground hover:text-foreground md:hover:bg-secondary"
                }`
              }
            >
              <Icon className="h-5 w-5" strokeWidth={2} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
